import { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import DropdownMenu from "./DropDownMenu";
import MobileMenu from "./MobileMenu";
import { IoMenu } from "react-icons/io5";



const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const mobileMenuRef = useRef(null);
    const { isAuthenticated, user, logout } = useAuth();
    const location = useLocation();

    const isTransparent =
        location.pathname === "/" ||
        location.pathname === "/producers" ||
        location.pathname === "/tickets" ||
        location.pathname === "/eventos";

    // Cerrar el menú móvil si se hace clic fuera
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        const isEventDetailRoute =
            location.pathname.startsWith("/eventos/") &&
            location.pathname !== "/eventos";
        const scrollThreshold = isEventDetailRoute ? 72 : 12;

        const handleScroll = () => {
            setIsScrolled(window.scrollY > scrollThreshold);
        };

        handleScroll();
        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => window.removeEventListener("scroll", handleScroll);
    }, [location.pathname]);

    return (
        <>
            {/* Header */}
            <header
                className={`w-full transition-all ${
                    isTransparent
                        ? `fixed inset-x-0 top-0 z-40 ${
                              isScrolled
                                  ? "bg-zinc-950/80 backdrop-blur-md md:backdrop-blur-xl border-b border-zinc-800/70 shadow-[0_10px_35px_rgba(0,0,0,0.35)]"
                                  : "bg-transparent"
                          }`
                        : "bg-transparent"
                }`}
                style={{ paddingTop: "env(safe-area-inset-top)" }}
            >
                <div className="flex items-center justify-between px-4 py-3 md:py-4">
                    {/* Logo */}
                    <Link to="/" className="text-2xl font-bold text-white">
                        <span className="text-yellow-cdg">Cat</span>Pass
                    </Link>

                    {/* Menú en pantallas grandes */}
                    <nav className="hidden md:flex space-x-4 items-center">
                        <Link to="/eventos" className="text-white hover:text-zinc-400">
                            Eventos
                        </Link>
                        <Link to="/producers" className="text-white hover:text-zinc-400">
                            Productoras
                        </Link>
                        <DropdownMenu isAuthenticated={isAuthenticated} user={user} logout={logout} />
                    </nav>

                    {/* Botón para menú móvil */}
                    <button
                        onClick={() => setIsOpen(!isOpen)}
                        className="mr-1 text-4xl text-white focus:outline-none md:hidden"
                        aria-label="Abrir menú móvil"
                    >
                        <IoMenu />
                    </button>
                </div>
            </header>

            {/* Menú móvil */}
            {isOpen && (
                <div className="fixed inset-0 z-50">
                    <MobileMenu ref={mobileMenuRef} setIsOpen={setIsOpen} isAuthenticated={isAuthenticated} logout={logout} />
                </div>
            )}
        </>
    );
};

export default Navbar;
